"use client";
import { Select, type SelectProps } from "../raw/Select";
import { useField } from "formik";

export function FormikSelect(
  props: SelectProps & { wrapperClass?: string; type?: "string" | "number" },
) {
  const { name } = props;
  const [field, meta, { setValue, setTouched }] = useField(name!);

  return (
    <Select
      {...field}
      // meta.touched so that it only show errors on the field we're on,
      // not all fields from the form
      error={meta.touched && meta.error}
      disabled={props.disabled}
      {...props}
      onChange={(val) => {
        // antd calls with value, formik expects event
        setValue(val);
        setTouched(true);
      }}
    />
  );
}
